import { Fragment } from 'react';
import { Space } from '../../space';
import { FormErrorItem } from '../types';

export type ValidateErrorProps = {
  errorList: FormErrorItem[];
  showErrorMessage?: boolean;
};

export const ValidateError = (props: ValidateErrorProps) => {
  return (
    <Fragment>
      {props.errorList.length > 0 && props.showErrorMessage && (
        <Space className="v-form-item-error-content" gap={10}>
          <span className="v-form-item-error-content-icon"></span>
          <span>{props.errorList[0]?.message}</span>
        </Space>
      )}
    </Fragment>
  );
};
